import React, { useState } from 'react';
import { Share2, Check } from 'lucide-react';

const ShareButton = ({ title, url, isDarkMode }) => {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    const shareData = {
      title: `Libro de Cielo - ${title}`,
      url: url || window.location.href
    };

    // Try native share API first (mobile devices)
    if (navigator.share) {
      try {
        await navigator.share(shareData);
        return;
      } catch (err) {
        // User cancelled or share not supported, fall through to copy
        if (err.name !== 'AbortError') {
          console.log('Share failed:', err);
        }
      }
    }

    // Fallback: Copy to clipboard
    try {
      await navigator.clipboard.writeText(shareData.url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = shareData.url;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <button
      onClick={handleShare}
      className={`inline-flex items-center space-x-2 px-4 py-2 rounded-lg font-semibold text-sm transition-all duration-300 ${
        copied
          ? isDarkMode
            ? 'bg-green-700 text-white'
            : 'bg-green-600 text-white'
          : isDarkMode
          ? 'bg-purple-700 hover:bg-purple-600 text-white'
          : 'bg-purple-600 hover:bg-purple-700 text-white'
      }`}
      title={copied ? 'Enlace copiado' : 'Compartir documento'}
    >
      {copied ? (
        <>
          <Check size={18} />
          <span>Copiado</span>
        </>
      ) : (
        <>
          <Share2 size={18} />
          <span>Compartir</span>
        </>
      )}
    </button>
  );
};

export default ShareButton;
